
import { Options, Vue, prop } from "vue-class-component";
import { KulionerController } from "@/app/ui/controllers/KulionerController";
import { KulionerConfirmOrderRequest } from "@/data/payload/api/KulionerApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import ModalSuccessAcceptOrder from "./modal-success-accept-order.vue";
import ModalFailedAcceptOrder from "./modal-failed-accept-order.vue";
import { KulionerOrder } from '@/domain/entities/Kulioner';
import generatePrintReceipt  from "./receipt"
import {
  ErrorMessageEntities,
} from "@/domain/entities/MainApp";

class Props {
  // data array dari list kulioner
  data = prop<KulionerOrder[]>({
    default: [],
    type: Array,
  });
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
  });
}

@Options({
  // emit jika proses berhasil, close modal
  emits: ["success", "failed", "onClose"],
  components: {
    ModalSuccessAcceptOrder,
    ModalFailedAcceptOrder
  }
})
export default class ModalProcessKulioner extends Vue.with(Props) {
  openModalSuccessAcceptOrder = false;
  openModalFailedAcceptOrder = false;

  columns = [
    {
      name: "No",
      styleHead: "table-process-kulioner-no",
      render: (item: any, index: any) => {
        return `<div class="font-semibold text-center text-gray-lp-300">${index + 1}</div>`;
      },
    },
    {
      name: "Order ID",
      styleHead: "table-process-kulioner-order-id",
      render: (item: KulionerOrder) => {
        return `<div class="font-semibold text-gray-lp-300">${item.koOrderId}</div>`;
      },
    },
    {
      name: "Merchant",
      styleHead: "table-process-kulioner-merchant",
      render: (item: KulionerOrder) => {
        return `<div class="text-gray-lp-300">
            <div class="font-medium break-all">
                ${item.koMerchantName || '-'}
            </div>
            <div class="text-gray-lp-600">
                ${item.koMerchantAddress}
            </div>
        </div>`;
      },
    },
    {
      name: "Penerima",
      styleHead: "table-process-kulioner-recipient",
      render: (item: KulionerOrder) => {
        return `<div class="font-medium text-gray-lp-300">${item.koRecipientName} (${this.maskingPhoneNumber(item.koRecipientPhoneNumber)})</div>`;
      },
    },
    {
      name: "Total kuantitas",
      styleHead: "table-process-kulioner-quantity",
      render: (item: KulionerOrder) => {
        const totalQuantity = item.koProduct.reduce((acc, curr) => {
          return acc + curr.kodQuantity
        }, 0)
        return `<div class="font-medium text-gray-lp-300">${totalQuantity}</div>`;
      },
    },
  ];

  maskingPhoneNumber(phoneNumber: string) {
    return phoneNumber ? phoneNumber.replace(/(\d{4})$/, "****") : '-';
  }

  onCloseModal() {
    this.$emit("onClose");
  }

  closeModal() {
    this.$emit("update:modelValue", false);
  }

  get dataKulioner() {
    return this.data;
  }

  isLoadingBtn = false;
  async onUpdate() {
    this.openModalSuccessAcceptOrder = false;
    this.openModalFailedAcceptOrder = false;
    MainAppController.showLoading();
    this.isLoadingBtn = true;
    
    try {
      const idKulioner = this.data.map((item) => item.koId);

      await KulionerController.updateKulioner(
        new KulionerConfirmOrderRequest({ id: idKulioner })
      );

      this.$emit('success', this.data);
      this.openModalSuccessAcceptOrder = true;
    } catch (error) {
      const err = error as any;

      if (err.response.status === 400) {
        this.$emit('failed', this.data);
        this.openModalFailedAcceptOrder = true;
      } else if (err.response.status === 500) {
        MainAppController.showErrorMessage(
          new ErrorMessageEntities({
            type: "error-token-ngen",
            title: "Pesanan gagal diterima",
            message: 'Terjadi gangguan sistem. Klik "Coba lagi" untuk memproses ulang.',
            buttonSuccessText: "Coba lagi",
            onTryAgain: () => this.onUpdate(),
          })
        );
      }
    } finally {
      this.isLoadingBtn = false;
      this.onCloseModal();
      MainAppController.closeLoading();
    }
  }

  async onPrintOrder() {
    this.openModalSuccessAcceptOrder = false;
    await generatePrintReceipt(this.data);
    this.$emit("refetch")
  }
}
